import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import inputValidation from "../../../utils/inputValidation";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import { treeActions } from "../../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";
function RenameWorkflowGroup(props) {
  const dispatch = useDispatch();
  const error = useRef(null);
  const { openModal, toggle } = props;
  const { t } = useTranslation();
  const { account } = useSelector((state) => state.queryParams);
  const parentScreen = useContext(ParentScreenCtx);
  // const value = useSelector(store => store.treeData.leftTree.tree.body.selectedNode.text);
  const selectedNode = useSelector(
    (state) =>
      state.treeData[parentScreen].leftTree.tree.body
        .selectedNode
  ); 
  const value = selectedNode?.title;
  const [input, setInput] = useState(value);
  const [valid, setValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [inputStyle, setInputStyle] = useState({});
  const style = {
    border: "1px solid #9f3a38",
    borderRadius: "0.28571429rem",
  };

  const handleClick = async () => {
    error.current.textContent = ""
    if (validateInput()) {
      try {
        setLoading(true)
        const response = await dispatch(api.endpoints.updateWorkflowName.initiate({
            account,
            currentName: value,
            newName: input.toLowerCase(),
          })
        );
        if(response.error){
          setLoading(false);
          throw new Error(response?.message || response?.data?.message || t("BOX_MSG_GENERAL_ERROR") )
        }
        if (response?.data?.current_state === "SUCCESS") {
            setLoading(false);
            dispatch(newTemplateActions.setShowAlert(true));
            dispatch(newTemplateActions.setAlertMessage(response.data.message));
            dispatch(
              treeActions.setLeftTreeContextActionValue({
                screen: parentScreen,
                data: (response?.data.workflow_name),
              })
            );

            dispatch(
              api.endpoints.getInboundTemplateList.initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            );
            dispatch(
              api.endpoints.getOutboundTemplateList.initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            );
            dispatch(
              api.endpoints.getWorkflows.initiate(
                { account },
                { subscribe: false, forceRefetch: true }
              )
            )
            toggle();
        } else {
          setLoading(false)
          error.current.textContent = response?.data?.message || t("BOX_MSG_GENERAL_ERROR") ;
          setValid(false);
        }
      } catch (err) {
        setLoading(false);
        error.current.textContent = err.message || t("BOX_MSG_GENERAL_ERROR");
      }
    }
  };
  const handleChange = (e) => {
    if(e.target.value.length > 50){
      const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");
      error.current.textContent = errorMsg;
      return;
    }
    setInput(e.target.value);
    error.current.textContent = "";
  };

  const validateInput = () => {
    if (inputValidation(input) === "") {
      error.current.textContent = t("BOX_ENTER_NEW_NM_FOR_NEW_WF_GROUP");
      setValid(false);
      return false;
    } else if (inputValidation(input) === "invalid") {
      error.current.textContent = t(
        "BOX_WF_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES"
      );
      setValid(false);
      return false;
    } else if(input.length > 50){
      const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");
      error.current.textContent = errorMsg;
      setValid(false);
      return false;
    }
    return true;
  };

  const handleCancelClick = () => {
    setInput(value);
    setValid(true);
    toggle();
  };

  useEffect(() => {
    setInput(value);
  }, [value]);

  return (
    <>
      <Dialog onClose={props.onClose} open={openModal} maxWidth="xs">
        <DialogTitle className="dialog-header">
          <div className="title">{t("DIAG_RENAME_WORKFLOW_GROUP_TIT")}</div>
          <div className="description">
            {/* <span style={{ fontSize: '1rem' }}> */}
            {t("BOX_ENTER_NEW_NM_FOR_NEW_WF_GROUP")}
            {/* </span> */}
          </div>
        </DialogTitle>
        <DialogContent className="modal-content" dividers>
          <div style={{marginBottom: "1.5rem" }}>
            <span>
              {t("WIZ_RENAME_WF_GROUP_1_MESSAGE").substring(
                0,
                t("WIZ_RENAME_WF_GROUP_1_MESSAGE").indexOf(".") + 1
              )}
            </span>
          </div>
          <div className={"default-delimiter-field"}>
            {/* <label style={{ width: '186px' }}>{t('LBL_NEW_WF_GROUP_NAME')}</label> */}
            <TextField
              type="text"
              variant="outlined"
              size="small"
              autoFocus={true}
              value={input}
              error={!valid}
              label={t("LBL_NEW_WF_GROUP_NAME")}
              onChange={(e) => {
                handleChange(e);
                setValid(true);
              }}
            />
          </div>
          <p className="error" ref={error}></p>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={!valid}
            onClick={() => handleClick()}>
            { loading ? <CircularProgress size="20px" color='primary' /> : t("BTN_OK") }
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handleCancelClick()}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RenameWorkflowGroup;
